    // main
export const firebaseConfigProd = {
    apiKey: "AIzaSyBQt1G6b7ZuvoCQxMuBP29iKOcbDPQ8mGk",
    authDomain: "guidozorn.firebaseapp.com",
    databaseURL: "https://guidozorn-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "guidozorn",
    storageBucket: "guidozorn.firebasestorage.app",
    messagingSenderId: "532249338913",
    appId: "1:532249338913:web:02bdcc9b153f0212b36f60",
    measurementId: "G-MZ2D3CED44"
};
    
// admin main
export const firebaseConfigProdADMIN = {
    apiKey: "AIzaSyBQt1G6b7ZuvoCQxMuBP29iKOcbDPQ8mGk",
    authDomain: "guidozorn.firebaseapp.com",
    databaseURL: "https://guidozorn-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "guidozorn",
    storageBucket: "guidozorn.firebasestorage.app",
    messagingSenderId: "532249338913",
    appId: "1:532249338913:web:12ed0b1f001e4984b36f60",
    measurementId: "G-KXNNH3D3GQ"
};
    
// dev
export const firebaseConfigDev = {
  apiKey: "AIzaSyAi0OG6UGR8eDiLUxejtov-LhiOwJhAolo",
  authDomain: "guidozorn-dev.firebaseapp.com",
  databaseURL: "https://guidozorn-dev-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "guidozorn-dev",
  storageBucket: "guidozorn-dev.firebasestorage.app",
  messagingSenderId: "167539941546",
  appId: "1:167539941546:web:db2c049cbb1d676bd330d3",
  measurementId: "G-8TBQVD5LRN"
};
    
// admin dev
export const firebaseConfigDevADMIN = {
    apiKey: "AIzaSyAi0OG6UGR8eDiLUxejtov-LhiOwJhAolo",
    authDomain: "guidozorn-dev.firebaseapp.com",
    databaseURL: "https://guidozorn-dev-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "guidozorn-dev",
    storageBucket: "guidozorn-dev.firebasestorage.app",
    messagingSenderId: "167539941546",
    appId: "1:167539941546:web:6e6074e7eccd6f2dd330d3",
    measurementId: "G-ZPKC45X98K"
};